/* àura theme — minimal interactivity */
(function () {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  const moneyFormat = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
    ? window.Shopify.currency.active
    : 'USD';

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return `${moneyFormat} ${value}`;
  }

  /* ---------- Mobile nav ---------- */
  const menuToggle = $('[data-menu-toggle]');
  const nav = $('[data-nav]');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      nav.classList.toggle('is-open');
    });
  }

  /* ---------- Cart Drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  const overlay = $('[data-cart-overlay]');
  const openers = $$('[data-open-cart]');
  const closers = $$('[data-close-cart]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  openers.forEach((o) => o.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  closers.forEach((c) => c.addEventListener('click', closeCart));
  overlay && overlay.addEventListener('click', closeCart);

  /* ---------- Cart fetch / render ---------- */
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function renderCart(cart) {
    const itemsEl = $('[data-cart-items]');
    const totalEl = $('[data-cart-total]');
    const countEls = $$('[data-cart-count]');
    const checkoutBtn = $('[data-cart-checkout]');
    if (!itemsEl) return;

    countEls.forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is quietly waiting.</p></div>';
      totalEl && (totalEl.textContent = '');
      checkoutBtn && (checkoutBtn.disabled = true);
      return;
    }

    checkoutBtn && (checkoutBtn.disabled = false);
    itemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-item" data-line-key="${item.key}">
        <a href="${item.url}" class="cart-item__media">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
        </a>
        <div>
          <h4 class="cart-item__title">${item.product_title}</h4>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__qty">
            <button data-qty-change="${item.key}" data-qty="${Math.max(0, item.quantity - 1)}" aria-label="Decrease">−</button>
            <span>${item.quantity}</span>
            <button data-qty-change="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
          </div>
          <button class="cart-item__remove" data-qty-change="${item.key}" data-qty="0">Remove</button>
        </div>
        <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
      </div>
    `).join('');
    totalEl && (totalEl.textContent = formatMoney(cart.total_price));

    $$('[data-qty-change]', itemsEl).forEach((btn) => {
      btn.addEventListener('click', async () => {
        const key = btn.getAttribute('data-qty-change');
        const qty = parseInt(btn.getAttribute('data-qty'), 10);
        await changeLine(key, qty);
      });
    });
  }

  async function refreshCart() {
    try {
      const cart = await fetchCart();
      renderCart(cart);
    } catch (e) { console.error(e); }
  }

  async function changeLine(id, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id, quantity })
      });
      const cart = await res.json();
      renderCart(cart);
    } catch (e) { console.error(e); }
  }

  /* ---------- Add to cart (AJAX) ---------- */
  $$('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const original = submitBtn ? submitBtn.textContent : '';
      submitBtn && (submitBtn.disabled = true, submitBtn.textContent = 'Adding…');
      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        if (!res.ok) throw new Error('Failed to add');
        await refreshCart();
        openCart();
      } catch (err) {
        console.error(err);
        alert('Sorry, we couldn\u2019t add that item.');
      } finally {
        submitBtn && (submitBtn.disabled = false, submitBtn.textContent = original);
      }
    });
  });

  /* ---------- Variant selection ---------- */
  $$('[data-variant-form]').forEach((form) => {
    const variantsScript = form.querySelector('[data-variants-json]');
    if (!variantsScript) return;
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    const variantInput = form.querySelector('[name="id"]');
    const priceEl = form.querySelector('[data-product-price]');
    const submitBtn = form.querySelector('[type="submit"]');
    const optionInputs = $$('input[data-option-index]', form);

    function selectVariant() {
      const selectedOptions = [];
      const groups = {};
      optionInputs.forEach((input) => {
        const idx = parseInt(input.getAttribute('data-option-index'), 10);
        if (input.checked) groups[idx] = input.value;
      });
      Object.keys(groups).sort().forEach((k) => selectedOptions.push(groups[k]));

      const variant = variants.find((v) =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
      if (!variant) return;
      variantInput.value = variant.id;
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = `<span class="price--compare">${formatMoney(variant.compare_at_price)}</span><span class="price--sale">${formatMoney(variant.price)}</span>`;
        } else {
          priceEl.textContent = formatMoney(variant.price);
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    }
    optionInputs.forEach((input) => input.addEventListener('change', selectVariant));
    selectVariant();
  });

  /* ---------- Product gallery thumbs ---------- */
  $$('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main] img');
    $$('[data-gallery-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const url = thumb.getAttribute('data-image');
        if (main && url) main.src = url;
        $$('[data-gallery-thumb]', gallery).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Initial cart count ---------- */
  refreshCart();
})();
